import { GoogleLogin } from "@react-oauth/google";
import { axiosHttp } from "../../wrapper/AxiosWrapper";
import { HttpStatusCode } from "axios";
import { useAuthentication } from "../../providers/AuthenticationProvider";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import Box from "@mui/material/Box";
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import SignInView from "./SignInView";
import SignUpView from "./SignUpView";
import { useSignInSignUp } from "../../providers/v2/SignInSignUpProvider";
import Typography from "@mui/material/Typography";
import { useTheme } from "@mui/material/styles";
import CheckIcon from "@mui/icons-material/CheckCircleOutline";
import OtpVerificationView from "./OtpVerificationView";
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import Link from "@mui/material/Link";
import Alert from "@mui/material/Alert";
import ForgotPasswordView from "./ForgotPasswordView";

const AuthenticationModalView = (props) => {

  const { logedInSuccess } = useAuthentication();
  const { userData, setUserData, activeTab, setActiveTab, singnIn } = useSignInSignUp();

  const theme = useTheme();

  const handleChange = (event, selectedTab) => {
    setActiveTab(selectedTab);
  };

  const handleOtpVerified = (responseData) => {
    if (responseData.status === HttpStatusCode.Ok) {
      setUserData({ ...userData, state: "EMAIL_VERIFIED", otpVerifyToken: responseData.content.otpVerifyToken });
    } else {
      setUserData({ ...userData, responseError: "EMAIL_VERIFICATION_FAILED" })
    }
  }

  const getDialogTitle = () => {
    if (userData.state === "INITIATED") {
      return activeTab === 'sign-in' ? "Sign In" : "Sign Up"
    } else if (userData.state === "FORGOT_PASSWORD") {
      return "Forgot Password"
    }
  }

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <Dialog open={props.open} onClose={props.close} fullWidth maxWidth="sm"
        sx={{
          "& .MuiDialog-paper": {
            borderRadius: 4
          },
        }}
      >
        <DialogTitle>{getDialogTitle()}</DialogTitle>
        <DialogContent sx={{ p: 0 }}>
          <Box sx={{ width: '100%', typography: 'body1' }}>
            {userData.state === "INITIATED" &&
              <Box sx={{ p: { xs: 1, md: 2 } }}>
                <TabContext value={activeTab}>
                  <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <TabList onChange={handleChange} aria-label="Dss authentication view">
                      <Tab label="Sign In" value="sign-in" sx={{ textTransform: "none" }} />
                      <Tab label="Sign Up" value="sign-up" sx={{ textTransform: "none" }} />
                    </TabList>
                  </Box>
                  <TabPanel value="sign-in">
                    <SignInView/>
                  </TabPanel>
                  <TabPanel value="sign-up">
                    <SignUpView />
                  </TabPanel>
                </TabContext>
              </Box>
            }
            {userData.state === "VERIFY_OTP" &&
              <Box>
                <Box sx={{
                  height: 110,
                  p: 2.5,
                  mt: 1,
                  //backgroundColor: theme.palette.primary.main,
                  textAlign: "center"
                }}>
                  <CheckIcon sx={{ color: theme.palette.primary.main, fontSize: 32 }} />
                  <Typography variant="h6" sx={{ color: theme.palette.primary.main }}>Congragulation</Typography>
                  <Typography variant="body1" sx={{ color: theme.palette.primary.main }}>Your account has been successfully created.</Typography>
                </Box>
                <Box sx={{ textAlign: "center", p: 2.5, }} className="animate-fade-in">
                  <Typography variant="h6">Verify email address.</Typography>
                  <Typography sx={{ mt: 1, fontWeight: 500 }}> Please enter the OTP sent to your email.</Typography>
                  <Typography sx={{ opacity: .6 }}>{userData.email}</Typography>
                  <OtpVerificationView ref="sign-up" token={userData.token} verifyCallback={handleOtpVerified} />

                  {userData.responseError === "EMAIL_VERIFICATION_FAILED" &&
                    <Alert sx={{ mt: 1, borderRadius: 3 }} severity="error">
                      <Typography>Email verification failed. Please check the OTP received.</Typography>
                      <Typography>or</Typography>
                      <Typography>Click Resend OTP and try again.</Typography>
                    </Alert>
                  }

                </Box>
              </Box>
            }

            {userData.state === "CREATED" &&
              <Box>
                <Box sx={{
                  p: 2.5,
                  mt: 1,
                  textAlign: "center",
                  mb: 1
                }}>
                  <CheckIcon sx={{ color: theme.palette.primary.main, fontSize: 32 }} />
                  <Typography variant="h6" sx={{ color: theme.palette.primary.main }}>Congragulation!</Typography>
                  <Typography variant="body1" sx={{ color: theme.palette.primary.main, mt: 1 }}>Your account has been successfully created.</Typography>
                  <Typography variant="body2" sx={{ mt: 1 }}>You can now {<Link component="button" onClick={singnIn} sx={{ textDecoration: "none" }}>Sign in</Link>} with your new account.</Typography>
                </Box>
              </Box>
            }

            {userData.state === "EMAIL_VERIFIED" &&
              <Box sx={{
                p: 2.5,
                textAlign: "center"
              }}>
                <CheckIcon sx={{ color: theme.palette.primary.main, fontSize: 32 }} />
                <Typography variant="h6" sx={{ color: theme.palette.primary.main }}>Your email has been verified.</Typography>
                <Typography variant="body1" sx={{ mt: 1 }}>You can now {<Link component="button" onClick={singnIn} sx={{ textDecoration: "none" }}>Sign in</Link>} with your new account.</Typography>
              </Box>
            }

            {userData.state === "FORGOT_PASSWORD" &&
             <ForgotPasswordView onClose={props.close}/>
            }

          </Box>

        </DialogContent>
      </Dialog>
    </LocalizationProvider>
  )
}
export default AuthenticationModalView;